<template>
  <div />
</template>

<script setup>
import useAlert from '@global/composable/useAlert';
import { onMounted } from 'vue';
import $ from 'jquery';

const { closeAlert } = useAlert();

const props = defineProps({
  alert: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

onMounted(() => {
  // URL btn-close-alert 是黑色的, btn-cancel-alert 是白色按鈕
  $('.btn-close-alert, .btn-cancel-alert').on('click', (e) => {
    closeAlert(props.index);
  });

  $('.btn-confirm-alert').on('click', (e) => {
    if (typeof props.alert.callback === 'function') {
      props.alert.callback();
    }
    closeAlert(props.index);
  });
});
</script>
